import {Component, store} from 'Generic';
import {getGatewayIncentiveDetails, toggleGatewayIncentive, updateGatewayIncentiveBox} from 'Generic/lib';

export default class GatewayIncentive extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('#gateway-incentive-wrapper'),
      state: store.state,
    });
  }

  render() {
    let gatewayIncentiveHtml = '';
    const gatewayIncentivePlanDetails = getGatewayIncentiveDetails();

    if (gatewayIncentivePlanDetails) {
      gatewayIncentiveHtml = gatewayIncentivePlanDetails.html;
    } else {
      const gatewayIncentiveElement = document?.querySelector('#gateway-incentive-wrapper');
      if (gatewayIncentiveElement && window.getComputedStyle(gatewayIncentiveElement).display === 'block') {
        toggleGatewayIncentive(false);
      }
    }

    updateGatewayIncentiveBox(gatewayIncentivePlanDetails, this, gatewayIncentiveHtml);
  }
}
